import React, { useState,useEffect } from "react";
import ExperienceDiv from "./ExperienceDiv";
import ExperienceModal from "./ExperienceModal";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';


function CandidateOverviewExperience({data,getUpdatedData}) {
const [experienceData,setExperienceData]=useState(data)
const [editData,setEditData]=useState({})
const [experienceModal,setExperienceModal]=useState(false)


useEffect(()=>{
  setExperienceData(data)
  },[data])

const onEditExperience=(data)=>{
setEditData(data)
setExperienceModal(true) 
}



const onAddExperienceData=()=>{
     setEditData({})
     setExperienceModal(true) 
 }


  return (
    <>
      <div className="candidate-about__r7-professional-experience">
<div className='container_sections_wrapper'>

<h3 style={{ fontWeight:'700',
fontSize:'17px',color: '#373a40'}}>Experience</h3>
<div onClick={onAddExperienceData} className="add_icon">
<AddCircleOutlineIcon fontSize="large" style={{marginTop:'3px',marginLeft:'45px'}} />
</div>       

   </div>


<div className="r9-education__c1-education-div">
{
          experienceData && 
            experienceData?.map((experience, index) => {
              // console.log({experience})
              return <ExperienceDiv key={index} experience={experience} onEdit={onEditExperience}/>;
            })

        }
</div> 


      </div>
      {experienceModal && (<ExperienceModal editData={editData} isVisible={experienceModal} onClose={()=>{
        getUpdatedData()
        setExperienceModal(!experienceModal)
      }
      }/>)}

    </>
  );
}

export default CandidateOverviewExperience;
